<template>
  <b-card no-body class="my-2">
    <b-card-header>
      Movimientos

      <div class="w-100 d-flex justify-content-end align-items-center">
        <div class="dropdown no-caret">
          <button
            class="btn btn-transparent-dark btn-icon dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            <i data-feather="more-vertical"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right animated--fade-in-up">
            <a class="dropdown-item my-cursor">
              Recargar
            </a>
          </div>
        </div>
      </div>
    </b-card-header>

    <b-card-body class="p-1">
      <b-table
        :items="getMovimientosOfCurrentTraspaso"
        :fields="fields"
        show-empty
        responsive
        sticky-header
        style="height: 300px"
      >
        <template #cell(importe)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.importe) }}
          </div>
        </template>
        <template #cell(enero)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.enero) }}
          </div>
        </template>
        <template #cell(febrero)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.febrero) }}
          </div>
        </template>
        <template #cell(marzo)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.marzo) }}
          </div>
        </template>
        <template #cell(abril)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.abril) }}
          </div>
        </template>
        <template #cell(mayo)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.mayo) }}
          </div>
        </template>
        <template #cell(junio)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.junio) }}
          </div>
        </template>
        <template #cell(julio)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.julio) }}
          </div>
        </template>
        <template #cell(agosto)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.agosto) }}
          </div>
        </template>
        <template #cell(septiembre)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.septiembre) }}
          </div>
        </template>
        <template #cell(octubre)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.octubre) }}
          </div>
        </template>
        <template #cell(noviembre)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.noviembre) }}
          </div>
        </template>
        <template #cell(diciembre)="data">
          <div class="text-primary text-center w-100">
            {{ $formatNumber(data.item.diciembre) }}
          </div>
        </template>
      </b-table>
    </b-card-body>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MovimientosList',

  props: {
    traspaso: {
      type: Object,
      default: () => ({})
    }
  },

  created () {
    this.$store.commit('recursoFederalModule/setCurrentTraspaso', [])

    //
    // Obtiene el item desde un dispatch
    this.$store.dispatch('recursoFederalModule/getById', this.traspaso.id)
  },

  data () {
    return {
      fields: ['unidad_administrativa', 'proyecto', 'partida', 'fuente_financiamiento', 'importe',
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
    }
  },

  computed: {
    ...mapGetters('recursoFederalModule', ['getMovimientosOfCurrentTraspaso'])
  }
}
</script>
